import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useChecklistContext } from "context/ChecklistContext";
import { useDeleteChecklistMutation } from "app/api/checklists";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

const DeleteChecklist: React.FC = () => {
  const navigate = useNavigate();
  const { checklist } = useChecklistContext();
  const [showModal, setShowModal] = useState(false);
  const [deleteChecklist, { isLoading: isDeleting }] = useDeleteChecklistMutation();

  const hasProducts = !!checklist.installedProducts?.length || !!checklist.serialEntities?.length;

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDeleteChecklist = async () => {
    if (!checklist.id) return;

    try {
      await deleteChecklist({ checklistId: checklist.id, orderId: checklist.partOfOrder }).unwrap();
      toast.success("Checklistan har raderats!");
      setShowModal(false);
      navigate(`/orders/view/${checklist.partOfOrder}`);
    } catch (error) {
      toast.error(error?.["data"] || "Något gick fel vid radering av checklistan");
    }
  };

  return (
    <>
      <Dialog open={showModal} onClose={handleClose}>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Radera checklistan "{checklist.roomName}"?
          <IconButton aria-label="close" size="small" onClick={handleClose}>
            <ClearIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography>
            Tar bort checklistan och all data kopplad till den, så som bilder och kommentarer.
          </Typography>

          {hasProducts && (
            <Alert severity="error">
              Checklistan kan inte raderas eftersom den innehåller installerade produkter.
            </Alert>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            loading={isDeleting}
            startIcon={<ClearIcon />}
            onClick={handleClose}
          >
            Avbryt
          </Button>

          <Button
            variant="contained"
            color="error"
            loading={isDeleting}
            disabled={hasProducts}
            startIcon={<DeleteIcon />}
            onClick={handleDeleteChecklist}
          >
            Radera
          </Button>
        </DialogActions>
      </Dialog>

      <Tooltip arrow title="Radera checklistan">
        <IconButton size="small" onClick={() => setShowModal(true)}>
          <DeleteIcon color="error" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default DeleteChecklist;
